<template>
  <cv-grid fullWidth id="bottoniera">
    <cv-row>
      <cv-column :sm="0" :md="8" :lg="16">
        <!-- Schermo medio o largo -->
        <cv-button kind="primary" :icon="svg_binoculars" style="margin-right: 1em"
                   @click="$emit('filtra-premuto')">Cerca i dati</cv-button>

        <cv-button kind="secondary" :icon="svg_pdf"
                   @click="$emit('pdf-premuto')">Apre il report</cv-button>
      </cv-column>

      <cv-column :sm="4" :md="0" :lg="0">
        <!-- Schermo piccolo -->
        <cv-button kind="primary" :icon="svg_binoculars" style="margin-right: 1em"
                   @click="$emit('filtra-premuto')">Cerca i dati</cv-button>
      </cv-column>
      <cv-column :sm="4" :md="0" :lg="0">
        <cv-button kind="secondary" :icon="svg_pdf"
                   @click="$emit('pdf-premuto')">Apre il report</cv-button>
      </cv-column>
    </cv-row>
  </cv-grid>
</template>

<script>
import Binoculars from '@carbon/icons-vue/es/binoculars/16';
import PDF from '@carbon/icons-vue/es/PDF/16';

export default {
  name: "BottonieraRicerche",
  data: function () {
    return {
      notifica_visibile: false,

      // icone dei bottoni
      svg_binoculars: Binoculars,
      svg_pdf: PDF
    }
  },
  methods: {
    actionClose: function () {
      this.notifica_visibile = false;
    }
  }
}
</script>

<style scoped>

</style>